import * as time from "./utils/time";
import * as unit from "./utils/units";
import * as data from "./log/ktt-data.js";
import * as table from "./utils/ktt-tables.js";
import * as svg from "./utils/ktt-svg.js";

export function HTMLDashboardBox(obj) {
  // Receive an Object with a "name" value and a "content" value.
  // "content" is HTML to be printed into the main div.
  if (obj) {
    return `
      <div class="gridbox" id="dashboard-${obj.name}">
        ${obj.content}
      </div>
    `;
  } else {
    return "";
  }
}

export function HTMLDataSleep() {
  // <li><label>Hours slept</label>:  ${data.getLogObjFromDate(window.viewQuery.queryDate).slept || ''}</li>
  // <li><label>Hours in bed</label>: ${data.getLogObjFromDate(window.viewQuery.queryDate).inBed }</li>
  return `
    <ul class="data-sleep">
      <li><label>Morning lie-in</label>: ${time.minsToHM(data.getTimeSleptLastNight())}</li>
      <li style="display:none"><label>Day started</label>:  </li>
    </ul>
  `;
}

export function HTMLDataFood() {
  return `
    <ul class="data-food">
      <li><label>Meal Count:</label> 1, [18:45] late period</li>
      <li><label>Breakfast:</label> </li>
      <li><label>Lunch:</label>: </li>
      <li><label>Dinner</label>: </li>
    </ul>
    `;
}

export function HTMLMoodFlow() {
  let moodFlow = window.viewQuery.queryObj.rhythmFlow.mood ? `<true>activate</true>` : `<false>no...</false>`;
  let energyFlow = window.viewQuery.queryObj.rhythmFlow.energy ? `<true>activate</true>` : `<false>no...</false>`;
  let clarityFlow = window.viewQuery.queryObj.rhythmFlow.clarity ? `<true>activate</true>` : `<false>no...</false>`;

  return `
    <ul class="mood-flow">
      <li><label>Mood-flow:</label> ${moodFlow}</li>
      <li><label>Energy-flow</label>: ${energyFlow}</li>
      <li><label>Clarity-flow</label>: ${clarityFlow}</li>
    </ul>
  `;
}

export function goalbox(goal) {
  const totalPracticed_this_period = goal.totalPracticedThisPeriod();
  const goalAttained = goal.attained();
  const overshoot = goal.overshoot();
  const category = "";
  const inPeriod = goal.isInPeriod();

  return `
    <div
      class="goalBox entry-wrap"
      onclick="displayTagOverlay('${goal.tag}')"
      data-tag="${goal.tag}"
      data-goalInPeriod="${inPeriod}"
      data-goalAttained="${goalAttained}"
      data-category="${category}">

      <span class="tag-label">${goal.tag}</span>
      <div class="tag-wrap" data-tag="${goal.tag}" style="width: calc(${goal.getTargetForThisPeriod()}px * var(--summaryEntryWidth) )">
        ${goalBar(goal)}
      </div>

      ${streakBoxes(goal)}

      <span class="label-duration">
        <span class="goal-practiced ${goalAttained}">
          <span class="overshoot">${overshoot}</span>
          ${time.minsToHM(totalPracticed_this_period || 0)}
        </span>
        /
        <span class="goal-target">${time.minsToHM(goal.getTargetForThisPeriod())}</span>
      </span>

      <div class="goal-format-wrap">${goal.goalFormatMessage("goal-format")}</div>
      <div class="goal-dates">${goal.goalDatesMessage("goal-dates")}</div>
      <div class="goal-description">${goal.description}</div>

    </div>
  `;
}

export function goalBar(destination, html = []) {
  // loop through the entries for this query
  // and populate the goal entries with the current progress

  // either we check for a given category list, or we default to the goals list.
  // destination as a category: window.fm.categories['category']
  // destination = destination ? destination : Object.keys(window.fm.goals);

  // check if destination is a goal
  // in the future set this check to be `destination.entryType == goal`

  // go through the query log
  Object.values(window.viewQuery.query).forEach((day) => {
    if (day.entries.length >= 1) {
      // get each entry for each day
      day.entries.forEach((entry) => {
        // get the tags for each entry
        entry.tags.map((tag) => {
          // if the tag is part of the goals, then...
          if (`${destination.tag}` == tag) {
            html.push(goalBarBlock(entry, tag, "#dashboard-goals .entries"));
          }
        });
      });
    }
  });

  return html.join("");
}

export function goalBarBlock(entry = {}, tag) {
  // `query` is an array of JS dates containing `Entry` objects.
  // Defaults to the current query.

  // Print out a block for each entry
  const minWidth = `calc( ${entry.duration}px * var(--summaryEntryWidth) )`;

  return `<div class="tag summary-entry" data-tag="${tag}" style="min-width: ${minWidth};"></div>`;
}

export function streakBoxes(goal) {
  // receives a goal object
  // returns HTML streak data to be inserted into a streak-wrap

  // get the streak data and insert its corresponding box into the streak-wrap
  if (goal.streak_data) {
    let count = 0;
    let streak_bits = "";
    let today = "";
    let query = "";
    let full = `<o class="full ${today} ${query}"></o>`;
    let partial = `<o class="partial ${today} ${query}"></o>`;
    let missed = `<o class="missed ${today} ${query}"></o>`;
    let skip = `<o class="skip ${today} ${query}"></o>`;
    let empty = `<o class="empty ${today} ${query}"></o>`;

    // print them out into the streak box etc
    goal.streak_data.forEach((key, val, arr) => {
      // adds a today class to the last block
      if (Object.is(arr.length - 1, val)) {
        today = "today";
        // console.log(partial)
      }
      let between_today_and_query = time.daysBetweenTwoDates(
        Object.entries(window.viewQuery.query)[0][0],
        window.viewQuery.today,
      );
      // console.log(between_today_and_query)
      let gap = arr.length - 1 - between_today_and_query;

      if (Object.is(gap, val)) {
        if (
          time.dateNoTime(Object.entries(window.viewQuery.query)[0][0]).getTime() <=
          time.dateNoTime(window.viewQuery.today.getTime())
        ) {
          query = "query";
        }
        // console.log(partial)
      } else {
        query = "";
      }

      // for as many days off as we are from today,
      // on that index, add a query class
      let full = `<o class="full ${today} ${query}"></o>`;
      let partial = `<o class="partial ${today} ${query}"></o>`;
      let missed = `<o class="missed ${today} ${query}"></o>`;
      let skip = `<o class="skip ${today} ${query}"></o>`;
      let empty = `<o class="empty ${today} ${query}"></o>`;

      // add each block to the array depending on its data
      switch (key) {
        case 0:
          streak_bits += missed;
          count = 0;
          break;
        case 1:
          streak_bits += partial;
          count++;
          break;
        case 2:
          streak_bits += full;
          count++;
          break;
        case 3:
          streak_bits += empty;
          break;
        case 4:
          streak_bits += skip;
          break;
      }
    });

    // Add blocks for days remaining from today
    // ======================================================
    streakBoxes.add_streak_days_remaining = function () {
      const streakHasStarted = time.compareTwoDatesExcludingTime(window.viewQuery.today, goal.date_start);
      const streakHasEnded = time.compareTwoDatesExcludingTime(window.viewQuery.today, goal.date_end);
      let compare_date;
      let query_gap_count = 0;

      if (streakHasStarted) {
        compare_date = window.viewQuery.today;
        query_gap_count++;
      } else {
        compare_date = goal.date_start;
      }

      let days_remaining = streakHasEnded
        ? time.daysBetweenTwoDates(goal.date_start, goal.date_end)
        : time.daysBetweenTwoDates(compare_date, goal.date_end);

      if (!streakHasStarted) {
        days_remaining++;
      } // temporary fix off-by one error...

      if (days_remaining) {
        const current_query = Object.entries(window.viewQuery.query)[0][0];
        const gap_between_query_and_streak_start = time.daysBetweenTwoDates(compare_date, current_query);

        while (days_remaining) {
          if (query_gap_count == gap_between_query_and_streak_start) {
            if (time.dateNoTime(current_query).getTime() >= time.dateNoTime(compare_date.getTime())) {
              query = "query";
            }
          } else {
            query = "";
          }

          query_gap_count++;
          days_remaining--;
          streak_bits += `<o class="empty ${query}"></o> `;
        }
      }
    };

    // if its not a week or month view that's in the past, then show remaining streak blocks
    if (
      !(
        time.getQueryTimeSpan() != "day" &&
        time.compareTwoDatesExcludingTime(window.viewQuery.today, window.viewQuery.queryDateLast)
      )
    ) {
      streakBoxes.add_streak_days_remaining();
    }

    let count_total_num = goal.streak_dates_total || "";
    let count_total = "";
    if (count_total_num) {
      count_total = `/ <count class="total">${count_total_num}</count>`;
    }
    goal.streak_current = count;

    let streak_box = `
      <div class="streak-wrap">
        <div class="streak-bits">
          ${streak_bits}
        </div>
        <div class="counters">
          <count class="current">${count}</count>
          ${count_total}
        </div>
      </div>`;
    // console.log('-----')
    return streak_box;
  } else {
    // return empty non-box
    return "";
  }
}

export function tagData(tagObj) {
  // console.log("Tag Data: ")
  // console.log(tagObj)
  // todo: check this so we can always be sure tagObj.data is ready in time.
  if (!tagObj.data) return;

  // duration week: get each week obj, sum all the data for it with
  return `
    <div class="tag_data">
      <div class="group_durations">
        <span>Today:   ${unit.val(time.minsToHM(window.viewQuery.querySummary.mainSummaryList[tagObj.name]))}</span>
        <span>Total:   ${unit.val(time.minsToHM(tagObj.total))}</span>
      </div>

      <div class="group_sessions">
        Per Session:
          <span>${unit.val(time.minsToHM(tagObj.data.hi), "Hi:")}</span>
          <span>${unit.val(time.minsToHM(tagObj.data.av), "Avg:")}</span>
          <span>${unit.val(time.minsToHM(tagObj.data.lo), "Low:")}</span>
      </div>

      <div class="group_entries">
        <span>Entries: ${unit.val(tagObj.entries.length)}</span>
      </div>

      <div class="group_periods">
        Per Week:
        ${unit.val(time.minsToHM(tagObj.summary.avg_week))}
        <span>Per Month</span>
        <span>Per Quarter</span>
        <span>Per Year</span>
      </div>

      <div class="group_calendar">
        <span>Days:    ${unit.val(tagObj.days.length)}</span>
        <span>Since:   ${unit.val(time.dateFormatterJStoYYYYMMDD(tagObj.date_first))}</span>
        <span>Span:    ${tagObj.span}</span>
      </div>

      <div class="group_rhythms">
        Avg
         <span>Mood</span>
         <span>Energy</span>
         <span>Clarity</span>
      </div>

    </div>
  `;
}

export function streakPill(goalID, size = "normal") {
  let goal = window.fm.goals[goalID];
  let date_start = time.dateFormatterJStoYYYYMMDD(goal.date_start) || "Until";
  let date_end = time.dateFormatterJStoYYYYMMDD(goal.date_end) || "Onward";

  let practice_this_period = "";
  let period = "";
  if (time.getQueryTimeSpan() == "week") {
    period = "week";
  } else if (time.getQueryTimeSpan() == "month") {
    period = "month";
  }
  if (time.getQueryTimeSpan() != "day") {
    // practice_this_period = `
    //   <li><label>Practice this ${period}:</label> <val>${time.minsToHM(goal... )}</val></li></br>`;
  }

  // weekly avg = get totals for each week, then add up the weekly totals and divide by num of weeks.

  let collapsed = goal.isGoalActive() ? "" : "collapsed"; // default to collapsed if this chart ended before the query date.

  return `
    <div class="goal-display ${size}">

      <div class="goal-header" onclick="toggleClass('data-${goalID}', 'collapsed')">
        <h4 class='streak_goal'><strong>Streak Goal:</strong> ${date_start} - ${date_end}</h4>
        <h4 class='today'><strong>Today:</strong> ${time.minsToHM(goal.practiced_today)} / ${time.minsToHM(goal.getTargetForThisPeriod())}</h4>
        <h4 class='total'><strong>Total:</strong> ${time.minsToHM(goal.practiced_total)} / ${time.minsToHM(goal.target_total)}</h4>
      </div>

      <div class="goal-sections-wrapper collapsible ${collapsed}" id="data-${goalID}">
        <div class="goal-data-table">
          ${table.HTML_EntriesTable(goal.tagFromId(goal.ID), [...goal.entries_between_start_end].reverse())}
        </div>

        ${svg.HTML_SVG_Graph(goal.tagFromId(goal.ID), [...goal.streak_practiced_dates].reverse())}

        ${streakBoxes(goal)}

        <div class="detailed-data">
          <ul>
            ${practice_this_period}
            <li><label>Daily avg:</label> <val>${time.minsToHM(goal.practice_average)}</val></li>
            <li><label>Longest Day:</label> <val>${time.minsToHM(goal.practiced_longest)}</val></li>
            <li><label>Shortest Day:</label> <val>${time.minsToHM(goal.practiced_shortest)}</val></li>
            <li><label><strong>Total</strong>:</label> <val>${time.minsToHM(goal.practiced_total)}</val></li>
          </ul>
        </div>

      </div>

    </div>
    `;
}

export function streakListings(listOfGoalObjs, status = "all", size = "normal") {
  return listOfGoalObjs
    .filter((goalObj) => {
      return status == "all" ? goalObj : goalObj.isActive == status;
    })
    .map((goalObj) => streakPill(goalObj.ID, size))
    .join("");
}

export function divIfItDoesntExist(divID) {
  if (!document.getElementById(divID)) {
    document.getElementById("dashboard").insertAdjacentHTML(
      "beforeend",
      `
      <div id="${divID}">
      </div>
      `,
    );
  }
}

export function generateHTMLListFromJSON(JSON_data, list_type) {
  let li_list = "";
  for (let x = 0; x < Object.keys(JSON_data).length; x++) {
    let key_val = Object.entries(JSON_data)[x];
    li_list += `<li><key>${key_val[0]}</key> <time>${key_val[1]}</time></li>`;
  }
  return `<${list_type}>${li_list}</${list_type}>`;
}
